import React from 'react';
import { Col } from 'reactstrap';

const projectListCounter = (props) => {
    let message = '';
    if(props.categories) {
        if(props.projectsCount > 0) {
            message = `${props.projectsCount} Teilnehmende gefunden!`;
        } else {
            message = `Keine Teilnehmenden! Versuchen Sie eine andere Auswahl`;
        }
    } else {
        message = `Wir freuen uns über ${props.projectsCount} Teilnehmer!`;
    }

    return (
        <Col xs={12}>
            <span className="fw-bold">{message}</span>
        </Col>
    );
};

export default projectListCounter;
